"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveStagedSitemapChanges = exports.SaveSitemapChanges = exports.SaveSitemapChangesActionTypes = exports.loadSitemaps = exports.FetchSitemaps = exports.FetchSitemapsActionTypes = exports.SitemapsActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var SitemapsActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_SITE_MAPS: null,
  FETCH_SITE_MAPS: null,
  SAVE_SITE_MAP_CHANGES: null
}, 'sitemaps');
exports.SitemapsActionTypes = SitemapsActionTypes;
var FetchSitemapsActionTypes = (0, _actions.createRequestTypes)(SitemapsActionTypes.FETCH_SITE_MAPS);
exports.FetchSitemapsActionTypes = FetchSitemapsActionTypes;
var FetchSitemaps = (0, _actions.createRequestActions)(FetchSitemapsActionTypes);
exports.FetchSitemaps = FetchSitemaps;
var loadSitemaps = (0, _fluxActions.createAction)(SitemapsActionTypes.LOAD_SITE_MAPS);
exports.loadSitemaps = loadSitemaps;
var SaveSitemapChangesActionTypes = (0, _actions.createRequestTypes)(SitemapsActionTypes.SAVE_SITE_MAP_CHANGES);
exports.SaveSitemapChangesActionTypes = SaveSitemapChangesActionTypes;
var SaveSitemapChanges = (0, _actions.createRequestActions)(SaveSitemapChangesActionTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SaveSitemapChangesActionTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('marketing.pages.notifications.sitemaps.success')));
  },
  failureMetaCreator: function failureMetaCreator(_ref) {
    var responseJSON = _ref.responseJSON;

    var defaultMessage = _I18n.default.text('marketing.pages.notifications.sitemaps.error');

    var errorMessage = responseJSON && responseJSON.message ? responseJSON.message : defaultMessage;
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SaveSitemapChangesActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(errorMessage));
  }
});
exports.SaveSitemapChanges = SaveSitemapChanges;
var saveStagedSitemapChanges = (0, _fluxActions.createAction)(SitemapsActionTypes.SAVE_SITE_MAP_CHANGES, function (data) {
  return data;
});
exports.saveStagedSitemapChanges = saveStagedSitemapChanges;